import React, { useEffect } from "react";
import { Grid, Typography, Box, Button, } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
const background = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/playpoint-bg.png";
const playpointimg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/discover.png";
const playpointimg2 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/shop.png";
const playpointimg3 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/playpointimg3.png";
const playpointimg4 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/archive.png";
const playpointimg5 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/playpointimg5.png";
const playpointimg6 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/make.png";
const playGameBtn = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/playgame-button.png";
const visit = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Frame 1321316289.png";



const data = [
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/freemoney.png",
    title: "Reach Cashback Goal",
    description: "Shop & hit Cashback goals to get points and free money!",
    buttonImg: playGameBtn,
    link: "/savings-league/free-money",
  },
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/discover.png",
    title: "Discover brands",
    description: "Get 10 points for every unique brand you visit via CashKaro",
    buttonImg: playGameBtn,
    link: "/savings-league/discover-brand",
  },
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/collect.png",
    title: "Shop and Collect",
    description: "Get upto 400 points on every shopping via CashKaro",
    buttonImg: playGameBtn,
    link: "/savings-league/shop-collect",
  },
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brandofday.png",
    title: "Shop from Today’s Featured  Brand",
    description: "Don't miss out! Shop from our brand of the day & get 300 points",
    buttonImg: playGameBtn,
    link: "/savings-league/shop-brand",
  },
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/milestonee.png",
    title: "Achieve point milestones",
    description: "Unlock extra points. Get up to 1000 bonus points for reaching your milestone",
    buttonImg: playGameBtn,
    link: "/savings-league/achive-points",
  },
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/shopping-streak.png",
    title: "Maintain Shopping Streak",
    description: "Shop daily for 2, 3, or 5 days in a row and get up to 1000 points",
    buttonImg: playGameBtn,
    link: "/savings-league/maintain-shop",
  },
  {
    imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/higherr.png",
    title: "Higher the bill better the points",
    description: "Spend big, get big! Get up to 200 points when you spend ₹5,000, ₹7,500, or ₹10,000 in a day.",
    buttonImg: playGameBtn,
    link: "/savings-league/higher",
  },
];

export default function PlayPoints() {
  const navigate = useNavigate()
  const segment = localStorage.getItem('segment')
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Grid sx={{
          backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/diwali/bg_play.png)",
          backgroundSize: 'cover', // Ensures the image covers the entire container
          backgroundPosition: 'top', // Centers the background image
          backgroundRepeat: 'no-repeat' // Prevents the image from repeating
        }}
        >
          <Grid pt={12} pl={2} pr={2}>
            <Typography
              sx={{
                color: "#FFF",
                textAlign: "center",
                fontFamily: '"Montserrat Alternates"',
                fontSize: "20px",
                fontWeight: 900,
                lineHeight: "120%",
                padding: "0 10px",
                margin: "0 auto",
                position: "relative",
                zIndex: 22,
              }}
            >
              Play the games & start<br /> collecting points
            </Typography>
          </Grid>
          <Grid item xs={12} pl={2} pr={2} pb={10} sx={{
             paddingTop: '35px',
             '@media (min-width: 362px)': {
                 paddingTop: '60px', // apply padding-top for screen sizes >= 0px
               },
          }}>
            {/* {segment !== 1 && (
              <Grid pb={2} xs={12} sx={{
                paddingTop: '35px',
                '@media (min-width: 362px)': {
                    paddingTop: '80px', // apply padding-top for screen sizes >= 0px
                  },
              }}>
                <Box
                  sx={{
                    borderRadius: "16px",
                    border: "1px solid #452E6B",
                    background: "linear-gradient(180deg, #412C62 0%, #220F41 100%)",
                    padding: "16px",
                  }}
                >
                  <Box sx={{ width: "100%", marginBottom: "12px" }}>
                    <img src={visit} style={{ width: "100%" }} alt="Play Point" />
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <Box sx={{ width: "70%" }}>
                      <Typography
                        sx={{
                          color: "#FFF",
                          fontFamily: "Metropolis",
                          fontSize: "14px",
                          fontWeight: 700,
                          lineHeight: "140%",
                          textTransform: "capitalize",
                          marginBottom: "4px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Visit And Earn
                      </Typography>
                      <Typography
                        sx={{
                          color: "#E9E9E9",
                          fontFamily: "Metropolis",
                          fontSize: "12px",
                          fontWeight: 500,
                          lineHeight: "140%",
                        }}
                      >
                        Visit brands daily for 5 days in a row and get up to 100 points
                      </Typography>
                    </Box>
                    <Box style={{ position: "relative" }}>
                      <Box
                        style={{
                          borderRadius: "4.665px",
                          background: "#FFF",
                          filter: "blur(8px)",
                          display: "inline-flex",
                          height: "27.987px",
                          padding: "9.329px",
                          position: "absolute",
                          top: "12px",
                          left: "0",
                          width: "70px",
                          right: "0",
                          margin: "0 auto",
                        }}
                      ></Box>
                      <Button
                        onClick={() => navigate('/diwali-league/visit-earn')}
                        style={{
                          display: "inline-flex",
                          height: "33px",
                          minWidth: "80px",
                          padding: "11px",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "5.5px",
                          flexShrink: 0,
                          borderRadius: "5.5px",
                          background: "#FFF",
                          color: "#231043",
                          textAlign: "center",
                          fontFamily: "Metropolis",
                          fontSize: "11px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                          marginTop: "10px",
                          letterSpacing: "0",
                          textTransform: "capitalize",
                        }}
                      >
                        Play Game
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )} */}

            {data.map((item, index) => (
              <Grid key={index} pb={2} xs={12}>
                <Box
                  sx={{
                    borderRadius: "16px",
                    border: "1px solid #452E6B",
                    background: "linear-gradient(180deg, #412C62 0%, #220F41 100%)",
                    padding: "16px",
                  }}
                >
                  <Box sx={{ width: "100%", marginBottom: "12px" }}>
                    <img src={item.imgSrc} style={{ width: "100%" }} alt="Play Point" />
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <Box sx={{ width: "70%" }}>
                      <Typography
                        sx={{
                          color: "#FFF",
                          fontFamily: "Metropolis",
                          fontSize: "14px",
                          fontWeight: 700,
                          lineHeight: "140%",
                          textTransform: "capitalize",
                          marginBottom: "4px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#E9E9E9",
                          fontFamily: "Metropolis",
                          fontSize: "12px",
                          fontWeight: 500,
                          lineHeight: "140%",
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                    <Box style={{ position: "relative" }}>
                      <Box
                        style={{
                          borderRadius: "4.665px",
                          background: "#FFF",
                          filter: "blur(8px)",
                          display: "inline-flex",
                          height: "27.987px",
                          padding: "9.329px",
                          position: "absolute",
                          top: "12px",
                          left: "0",
                          width: "70px",
                          right: "0",
                          margin: "0 auto",
                        }}
                      ></Box>
                      <Button
                        onClick={() => navigate(item?.link)}
                        style={{
                          display: "inline-flex",
                          height: "33px",
                          minWidth: "80px",
                          padding: "11px",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "5.5px",
                          flexShrink: 0,
                          borderRadius: "5.5px",
                          background: "#FFF",
                          color: "#231043",
                          textAlign: "center",
                          fontFamily: "Metropolis",
                          fontSize: "11px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                          marginTop: "10px",
                          letterSpacing: "0",
                          textTransform: "capitalize",
                        }}
                      >
                        Play Game
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
    </Grid>
  );
}
